export default __webpack_public_path__ + "static/media/icon_phone.ceb51b09.svg";